import React from 'react';

const projects = [
  {
    title: 'Freelysta',
    domain: 'freelysta.com',
    description: 'A free freelancer management platform to run clients, projects, contracts, invoices, and payments from one workspace.',
    tags: ['SaaS', 'Freelance', 'Invoicing'],
    link: 'https://freelysta.com',
    shot: '/projects/freelysta-header.png',
  },
  {
    title: 'GoForCab',
    domain: 'goforcab.com',
    description: 'A premium cab booking service with 24/7 availability, professional drivers, and reliable rides across India.',
    tags: ['Mobility', 'Booking', 'Realtime'],
    link: 'https://goforcab.com',
    shot: '/projects/goforcab-header.png',
  },
  {
    title: 'AINOR',
    domain: 'myainor.com',
    description: 'A subscription-based web development agency offering websites, apps, and e-commerce from ₹9,999/month.',
    tags: ['Agency', 'Web', 'AI'],
    link: 'https://myainor.com',
    shot: '/projects/ainor-header.png',
  },
  {
    title: 'Livestayy',
    domain: 'livestayy.com',
    description: 'An automated operating system for PG and rental owners to track payments, manage tenants, and run properties from one dashboard.',
    tags: ['PropTech', 'Rentals', 'SaaS'],
    link: 'https://livestayy.com',
    shot: '/projects/livestayy-header.png',
  },
];

const Projects = () => {
  return (
    <section id="projects" className="section border-b border-[var(--line)]">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="t-kicker mb-4">Selected work</p>
            <h2 className="t-display text-5xl md:text-6xl">
              Four products,<br />all live.
            </h2>
          </div>
          <p className="t-body max-w-sm">
            Real companies, real users. Click through to the live sites.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project, index) => (
            <a
              key={project.title}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group no-underline rounded-3xl border border-[var(--line)] bg-[var(--bg-2)] overflow-hidden hover:border-[rgba(255,77,28,0.4)] transition-colors"
            >
              <div className="bg-white">
                <img
                  src={project.shot}
                  alt={`${project.title} homepage`}
                  className="w-full h-auto block"
                />
              </div>
              <div className="p-6">
                <p className="t-kicker mb-2">0{index + 1}</p>
                <div className="flex items-baseline justify-between gap-4 mb-3">
                  <h3 className="t-display text-3xl text-[var(--ink)]">{project.title}</h3>
                  <span className="text-sm text-[var(--signal)] shrink-0">Visit →</span>
                </div>
                <p className="text-sm text-[var(--muted)] mb-3">{project.domain}</p>
                <p className="t-body mb-4">{project.description}</p>
                <p className="text-xs tracking-wide text-[var(--muted)]">{project.tags.join('  ·  ')}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
